import { render, staticRenderFns } from "./Auth.List.Admin.vue?vue&type=template&id=080be05c&"
import script from "./Auth.List.Admin.vue?vue&type=script&lang=js&"
export * from "./Auth.List.Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports